module.exports = __webpack_public_path__ + "static/media/LemonPayment.95974351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonPayment.png
// module id = 471
// module chunks = 0